// Shared between every "Powered by Shosay" surface (wall footer, widget
// overlay, widget inline). Centralized so adding/removing a variant during
// the A/B test is a one-file change, and so all pills on a single pageview
// agree on which gradient to show — a module-level random pick ensures a
// host site that embeds three widgets doesn't see three different gradients.
export const POWERED_BY_VARIANTS = [
  { key: "orange-pink",   from: "#FF8F47", to: "#FF7AAC" },
  { key: "orange-red",    from: "#FF8F47", to: "#EB5F28" },
  { key: "orange-purple", from: "#FF8F47", to: "#6452a2" },
  { key: "pink-purple",   from: "#FF7AAC", to: "#6452a2" },
];

// Picked once per module load. Importers get the same variant for the
// lifetime of the page.
export const POWERED_BY_VARIANT =
  POWERED_BY_VARIANTS[Math.floor(Math.random() * POWERED_BY_VARIANTS.length)];

// Best-effort click tracking. sendBeacon survives navigation, fetch+keepalive
// is the fallback. Failures are swallowed — tracking should never break the
// pill itself.
export const trackPoweredByClick = (variantKey) => {
  try {
    const body = new Blob(
      [JSON.stringify({ variant: variantKey })],
      { type: "application/json" }
    );
    if (typeof navigator !== "undefined" && navigator.sendBeacon) {
      navigator.sendBeacon("/api/v1/powered_by_clicks", body);
    } else if (typeof fetch !== "undefined") {
      fetch("/api/v1/powered_by_clicks", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ variant: variantKey }),
        keepalive: true,
      });
    }
  } catch (e) { /* swallow — tracking is best-effort */ }
};

// Inline-style helper for the gradient text. Returned as a plain object so
// it can be spread into a React `style` prop.
export const gradientTextStyle = (variant) => ({
  backgroundImage: `linear-gradient(90deg, ${variant.from} 0%, ${variant.to} 100%)`,
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
  backgroundClip: "text",
  color: "transparent",
  fontWeight: 900,
});
